export const GET_NETWORK_ORDERS_SUMMARY_REQUEST = 'GET_NETWORK_ORDERS_SUMMARY_REQUEST';
export const GET_NETWORK_ORDERS_SUMMARY_DONE = 'GET_NETWORK_ORDERS_SUMMARY_DONE';
export const GET_NETWORK_ORDERS_SUMMARY_FAILED = 'GET_NETWORK_ORDERS_SUMMARY_FAILED';
